import { ExtendedAccountColumns, ExtendedAccountData } from '@/backend/features/contact-management/entities/extended-account/types';
import { ValueProvider } from '@juvare/common-form-ui/ValueProvider';
import { accountEntityName } from '@juvare/contact-management/backend/features/accounts/shared';
import { occupationEntityName } from '@juvare/credentialing/backend/config/classifiers/entities/entityTypes';
import { OccupationColumns, OccupationData } from '@juvare/credentialing/backend/config/shared';
import { useStorageClient } from '@juvare/platform-sdk-react/ui/hooks';
import { useTranslation } from 'react-i18next';

export function useAccountOccupationOptionsValueProvider(): ValueProvider {
    const { t } = useTranslation('rms');
    const accountStorage = useStorageClient<ExtendedAccountData, ExtendedAccountColumns>(accountEntityName);
    const occupationStorage = useStorageClient<OccupationData, OccupationColumns>(occupationEntityName);

    return {
        type: 'accountOccupations',
        label: t('badging.accountBadgeOccupations'),
        getValues: async (accountId: string) => {
            const account = await accountStorage.get(accountId);
            const occupations = await occupationStorage.listColumns(
                {
                    filter: [
                        {
                            id: account.columns.occupationIds,
                            op: 'in',
                        },
                    ],
                },
                'name',
            );

            return occupations.rows.map(({ id, columns }) => ({
                label: columns.name,
                value: id,
            }));
        },
    };
}
